import React, { useCallback } from 'react';
import { toast } from 'react-toastify';
import { useQuery, gql } from '@apollo/client';
import Lottie from 'react-lottie-player';

import AvailableDaysCounter from './components/AvailableDaysCounter';
import LeaveRequestForm from './components/LeaveRequestForm';
import animationData from 'Shared/spiner_blue.json';
import withErrorBoundary from 'Components/ErrorBoundary/ErrorBoundary';
import { logger } from 'RootShared/utility/ErrorLogger';
import useDocumentTitle from 'Shared/hooks/useDocumentTitle';

export const queryGetLeaveRequestData = gql`
  query TabLeaveRequestQuery @api(name: root) {
    vacationReasons {
      id
      text
      requiresAllocation
      requiresCompensatory
    }
    allocation {
      id
      daysLeft
      validFrom
      validUntil
      amount
      reason {
        id
        text
      }
    }
  }
`;

const TabLeaveRequest = () => {
  const { loading, data, error, refetch } = useQuery(queryGetLeaveRequestData);

  useDocumentTitle('Vacations — Leave Request');

  const getAvailableDaysCounterComponent = useCallback((data) => {
    const { allocation: allocations = [] } = data;

    if (allocations) {
      const allocationTypes = [...new Set(allocations.map((allocation) => allocation.reason.text))];

      const daysAvailableByType = [
        ...allocationTypes.map((type) => ({
          type: type,
          daysLeft: allocations.reduce(
            (accumulator, item) => (item.reason.text === type ? accumulator + item.daysLeft : accumulator),
            0
          ),
        })),
      ];
      return <AvailableDaysCounter daysAvailableByType={daysAvailableByType} />;
    }
  }, []);

  if (error) {
    logger.error(error);
    toast(error.message, {
      type: toast.TYPE.ERROR,
      autoClose: 3000,
      closeButton: true,
      hideProgressBar: false,
    });
  }

  return (
    <div className="container container_sm tab-leave-request" data-testid="leave-request-form">
      {loading && (
        <Lottie
          data-testid="tab_expenses_history"
          className="lottie"
          loop={true}
          play={true}
          animationData={animationData}
          width={100}
          style={{ width: 100, height: 100, margin: '0px auto' }}
        />
      )}
      {data && getAvailableDaysCounterComponent(data)}
      {data && <LeaveRequestForm data={data} handleDataReload={refetch} />}
    </div>
  );
};

export default withErrorBoundary(TabLeaveRequest);
